import { ENVIRONMENTS, env } from './env';

const GTM_CONTAINER_ID = 'GTM-WC7KC5';

/**
 * Initialises Google Consent Mode v2 defaults.
 * Only runs in production — consent must be established before GTM fires.
 */
export const initConsent = (): void => {
  if (env.environment !== ENVIRONMENTS.PRODUCTION) return;

  window.dataLayer = window.dataLayer || [];

  // GTM Consent Mode v2 requires the IArguments object to be pushed as a single
  // item — a regular function declaration is mandatory because arrow functions have
  // no `arguments` binding. The rest param is only for TypeScript call-site typing.
  function gtag(..._args: unknown[]) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments as unknown as Record<string, unknown>);
  }

  // Deny all consent by default for EU/EEA/UK + privacy regions
  gtag('consent', 'default', {
    ad_personalization: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    region: [
      'GB',
      'AT',
      'BE',
      'BG',
      'CH',
      'CY',
      'CZ',
      'DE',
      'DK',
      'EE',
      'ES',
      'FI',
      'FR',
      'GG',
      'GR',
      'HR',
      'HU',
      'IE',
      'IM',
      'IT',
      'JE',
      'LT',
      'LU',
      'LV',
      'MT',
      'NL',
      'PL',
      'PT',
      'RO',
      'SE',
      'SI',
      'SK',
      'IS',
      'LI',
      'NO',
      'AU',
      'NZ',
      'BR',
      'ZA',
      'US-06',
      'US-08',
      'US-09',
      'US-49',
      'US-51'
    ],
    wait_for_update: 500
  });

  // Grant all consent by default for all other regions
  gtag('consent', 'default', {
    ad_personalization: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500
  });

  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);
};

/**
 * Bootstraps Google Tag Manager by pushing the gtm.start event and
 * injecting the GTM script tag. Replaces the former public/gtm.js file.
 */
export const initGTM = (): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.prepend(script);
};
